import { IReviews } from '../../../interfaces/customer-experience-assistant/ICustomExperienceAssistant';

const LatestReviews = ({
  reviews,
  count,
}: {
  reviews: IReviews[];
  count: number;
}) => {
  const columns = [
    'Source',
    'Rating',
    'Reviewer',
    'Hotel',
    'Review',
    'Sentiment',
    'Recommendations',
    'Review Date',
    'Agent Review Date',
  ];

  return (
    <div className="bg-white rounded-2xl">
      <div className="flex-row">
        <h2 className="font-semibold text-lg md:text-xl p-3">Latest Reviews</h2>
        <p className="px-3 py-3 text-xs">
          {count ? `${reviews.length} out of ${count}` : null}
        </p>
      </div>
      <table
        data-qa="table-rows"
        className="w-full text-sm text-left text-[#202020]"
      >
        <thead className={`text-xs text-[#667085] font-medium bg-[#F7F9FC]`}>
          <tr>
            {columns.map((column) => (
              <th key={column} scope="col" className="p-4">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reviews.map((review) => (
            <tr key={review._id}>
              <td className="p-4 border-b text-xs">{review.platform}</td>
              <td className="p-4 border-b text-xs">
                {review.rating}/{review.rate_scale.split('-')[1]}
              </td>
              <td className="p-4 border-b text-xs">{review.reviewer}</td>
              <td className="p-4 border-b text-xs">{review.hotel}</td>
              <td className="p-4 border-b text-xs">{review.review_text}</td>
              <td className="p-4 border-b text-xs">{review.sentiment}</td>
              <td className="p-4 border-b text-xs">{review.recommendations}</td>
              <td className="p-4 border-b text-xs">{review.date}</td>
              <td className="p-4 border-b text-xs">{review.ai_review_date}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LatestReviews;
